module.exports = __webpack_public_path__ + "static/banner-5c47c162ee1a80cfe18f9a07d10dd70e.jpg";